var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "go-icon",
    clipPath: "url(#clip0_3091_10971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0598 6.00001L10.5301 6.5297L6.03007 11.0297L5.49803 11.5617L4.43632 10.5L4.966 9.97032L8.93632 6.00001L4.96835 2.0297L4.43632 1.50001L5.49803 0.438293L6.02772 0.967981L10.5277 5.46798L11.0598 6.00001Z",
    fill: "#0418D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3091_10971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12.998) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.da6684700b15c93114477b823ae4c1d7.svg";
export { ForwardRef as ReactComponent };